export class StartInspectionError extends Error {
  constructor(message: string = 'Failed to start inspection instance') {
    super(message);
    this.name = 'StartInspectionError';
  }
}
